import { apiCall } from "../../../services/api-service";
//Vendor list
export const getVendorListApi = async (params) => {
  try {
    const response = await apiCall("GET", "vendor", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);
  } finally {
  }
};
//Save Vendor
export const saveVendorAPI = async (body) => {
  try {
    const response = await apiCall("POST", "vendor", body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
//Update Vendor
export const updateVendorAPI = async (id, body) => {
  try {
    const response = await apiCall("PUT", `vendor/${id}`, body);
    console.log("change", response);
    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);

    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};
//Get Vendor
export const getVendorEditApi = async (id) => {
  try {
    const response = await apiCall("GET", `vendor/get/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);
  } finally {
  }
};
//delete Vendor
export const deleteVendorApi = async (id) => {
  try {
    const response = await apiCall("DELETE", `vendor/delete/${id}`);
    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);
  } finally {
  }
};
//Add Attachment
export const addAttachmentApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `vendor/attachment/${id}`, body);
    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);
  } finally {
  }
};
//Bulk Delete
export const bulkDeleteApi = async (body) => {
  try {
    const response = await apiCall("POST", "vendor/bulkdelete", body);
    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);
  } finally {
  }
};
//Product List for vendor
export const getProductListApi = async (params) => {
  try {
    const response = await apiCall("GET", `vendor/products/${params.vendor_id}`, null, {
      params: params,
    });

    return response;
  } catch (err) {
    console.error("Error fetching vendor:", err);
    throw err;
  }
};

// Update Vendor Status
export const updateVendorStatusApi = async (id, body) => {
  try {
    const response = await apiCall("PUT", `vendor/status_update/${id}`, body);
    return response;
  } catch (err) {
    console.error("Error updating vendor status:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download Vendor Report
export const downloadVendorReportApi = async (params) => {
  try {
    const response = await apiCall("GET", "vendor/download_report", null, {
      params: params,
    });
    return response;
  } catch (err) {
    console.error("Error downloading vendor report:", err);
    if (err.response && err.response.data) {
      return err.response;
    } else {
      return { data: { success: false, message: err.message } };
    }
  }
};

// Download base64 file utility
export const downloadBase64File = (base64String, fileName) => {
  try {
    const base64Data = base64String.replace(/^data:.*,/, "");
    const binary = atob(base64Data);
    const array = [];

    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    const blob = new Blob([new Uint8Array(array)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading file:", error);
  }
};
